/**
 * Check the display and visibility of element
 */
export default (window: Window, element: HTMLElement | Element) => {
  if (!window || !element) {
    return false;
  }

  const { display, visibility } = window.getComputedStyle(element);

  return !(display === 'none' || visibility === 'hidden');
};
